export default "__VITE_ASSET__BztD5Xe6__"